import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 25,
  },
  listDiv: {
    maxHeight: 425,
    overflow: 'auto',
    margin: theme.spacing(0, 0.5, 0, 3),
  },
  list: {
    width: '80%',
    maxWidth: '125ch',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default useStyles;
